import React from "react";
import { Element } from "react-scroll";
import { FaGraduationCap, FaSchool, FaUniversity } from "react-icons/fa";
import "./Education.css";

const Education = () => {
  const educationData = [
    {
      level: "University",
      institution: "Netaji Subhas University of Technology (NSUT), Delhi",
      degree: "B.Tech Electronics and Communication Engineering",
      specialization: "Artificial Intelligence and Machine Learning",
      period: "2022 - 2026",
      percentage: "7.37 CGPA",
      icon: <FaUniversity />,
    },
    {
      level: "12th Grade",
      institution: "Govt. Boys Sr. Sec. School, Dr. Mukherjee Nagar, Delhi",
      degree: "Senior Secondary Education",
      specialization: "Science (PCMB)",
      period: "2020 - 2021",
      percentage: "75.8%",
      icon: <FaSchool />,
    },
    {
      level: "10th Grade",
      institution: "Oscar Public School, Delhi",
      degree: "Secondary Education",
      specialization: "All Subjects",
      period: "2018 - 2019",
      percentage: "78.2%",
      icon: <FaGraduationCap />,
    },
  ];

  return (
    <Element name="education">
      <section className="education" style={{ padding: "2rem 2rem" }}>
        <div className="education-container">
          <h2 className="section-title">Education</h2>
          <div className="education-timeline">
            {educationData.map((edu, index) => (
              <div
                key={index}
                className="education-item"
                data-aos="fade-up"
                data-aos-delay={index * 10}
              >
                <div className="education-icon">{edu.icon}</div>
                <div className="education-content">
                  <div className="education-header">
                    <h3>{edu.level}</h3>
                    <span className="education-period">{edu.period}</span>
                  </div>
                  <h4>{edu.institution}</h4>
                  <p className="education-degree">{edu.degree}</p>
                  {edu.specialization && (
                    <p className="education-specialization">
                      Specialization: {edu.specialization}
                    </p>
                  )}
                  <div className="education-percentage">
                    <strong>{edu.percentage}</strong>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Education;
